export const FILE_TYPES = {
  petition: "petition",
  depreciation_receipt: "receipt",
  application_receipt: "receipt",
  third_party_receipt: "receipt",
  recourse_receipt: "receipt",
  damage_receipt: "receipt",
  policy: "policy",
  expert_report: "expert_report",
  expert_report1: "expert_report1",
  expert_report2: "expert_report2",
  expert_report3: "expert_report3",
  authority_report: "authority_report",
  arbitration_decision: "arbitration_decision",
  arbitration_decision1: "arbitration_decision1",
  petition1: "petition1",
  petition2: "petition2",
  petition3: "petition3",
  petition4: "petition4",
  policy1: "policy1",
  pre_created_document: "pre_created_document",
  additional_document: "additional_document",
};
